(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  (function () {
    function updateLeftLocalization() {
      var leftSelectors = document.querySelectorAll('.header__localization--left');

      leftSelectors.forEach(function (element) {
        var header = element.closest('.header');

        if (!header) return;

        element.style.left = '';
        element.style.setProperty('--localization-left-top', '50%');

        var headerRect = header.getBoundingClientRect();
        var icons = header.querySelector('.header__icons');

        if (icons) {
          var iconsRect = icons.getBoundingClientRect();

          if (iconsRect.height > 0) {
            var verticalCenter = iconsRect.top - headerRect.top + iconsRect.height / 2;
            element.style.setProperty('--localization-left-top', verticalCenter + 'px');
          }
        }

        var elementRect = element.getBoundingClientRect();

        if (elementRect.width === 0) return;

        var blockers = header.querySelectorAll('.header__heading-link, header-drawer');
        var maxRight = 0;

        blockers.forEach(function (blocker) {
          var blockerRect = blocker.getBoundingClientRect();

          if (blockerRect.width === 0 || blockerRect.height === 0) return;

          var overlaps =
            blockerRect.left < elementRect.right &&
            blockerRect.right > elementRect.left &&
            blockerRect.top < elementRect.bottom &&
            blockerRect.bottom > elementRect.top;

          if (overlaps) {
            maxRight = Math.max(maxRight, blockerRect.right - headerRect.left);
          }
        });

        if (maxRight > 0) {
          element.style.left = maxRight + 12 + 'px';
        }
      });
    }

    function updateWhenReady() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', updateLeftLocalization);
      } else {
        updateLeftLocalization();
      }
    }

    updateWhenReady();
    window.addEventListener('load', updateLeftLocalization);
    window.addEventListener('resize', updateLeftLocalization);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(updateLeftLocalization);
    }

    document.addEventListener('shopify:section:load', function () {
      window.requestAnimationFrame(updateLeftLocalization);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
